<template>
    <div class="loader_container">
        <div class="loader_content">
            <img src="../img/loading-black.gif" />
            <span v-show="message" style="margin-left: 20px; vertical-align:middle;">{{message}}</span>
            <span v-show="!message" style="margin-left: 20px; vertical-align:middle;">Loading...</span>
        </div>
    </div>
</template>

<script>
import loggingService from '../services/util/loggingService'

export default {
    name: 'loader',
    props: ['message'],
    data: function () {
        return {
            isDebug: false
        }
    },
    created () {
        loggingService.log(this.isDebug, 'Loader', 'created')
    },
    mounted () {
        loggingService.log(this.isDebug, 'Loader', 'mounted')
    }
}
</script>


<style>
.loader_container {
    position: absolute;
    height: 100%;
    width: 98.5%;
    background-color: rgba(236, 236, 236, 0.9);
    z-index: 100;
    text-align: center;
}

.loader_content {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    //        border: 1px solid blue;
}
</style>




// WEBPACK FOOTER //
// Loader.vue?700689bc